import { FC } from 'react';

import { nickNameInfoSlice } from '../../../store/slices/nickname/selectors';
import { useModifiers } from '../../../styles/hooks/useModifiers';
import { L12nText } from '../../text/L12nText';

import styles from './NickNameFooterMessage.module.css';

type NickNameEditFooterMessageProps = {
  isMobileEdit?: boolean;
};

export const NickNameEditFooterMessageConnected: FC<NickNameEditFooterMessageProps> = ({ isMobileEdit }) => {
  const { maxCount, remainingAttempts } = nickNameInfoSlice.getNickNameInfo();
  const supportingMessage = remainingAttempts ? 'SETTINGS_CHANGE_NICKNAME' : 'SETTINGS_MAX_LIMIT_NICKNAME';

  const mods = useModifiers(styles, 'nickName_settings_footer', {
    mobileEdit: isMobileEdit,
  });

  return (
    <div className={`${styles.nickName_settings_footer} ${mods}`}>
      <L12nText
        tk={supportingMessage}
        dynamicValues={[
          `${maxCount}`,
          `<span style="color:var(--core-color-text)">${remainingAttempts}/${maxCount}</span>`, // TODO: rework this, as triggers dangerouslySetInnerHTML
        ]}
        markdown={true}
      />
    </div>
  );
};
